<div class="admin-banner">
  <div class="admin-banner__message">
    <svg class="admin-banner__icon" width="20" height="20" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M8 1L2 3.5V7.5C2 11 4.5 14 8 15C11.5 14 14 11 14 7.5V3.5L8 1Z" fill="currentColor"/>
    </svg>
    <span class="admin-banner__title">SUPERADMIN MODE</span>
    <span class="admin-banner__divider"></span>
    <span class="admin-banner__text">You are viewing and managing data across every organization on the platform.</span>
  </div>

  <a routerLink="/" class="admin-banner__exit" aria-label="Exit superadmin mode">
    <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path fill-rule="evenodd" clip-rule="evenodd" d="M6 2.75A.75.75 0 016.75 2h5.5A2.75 2.75 0 0115 4.75v6.5A2.75 2.75 0 0112.25 14h-5.5a.75.75 0 010-1.5h5.5c.69 0 1.25-.56 1.25-1.25v-6.5c0-.69-.56-1.25-1.25-1.25h-5.5A.75.75 0 016 2.75Z" fill="currentColor"/>
      <path fill-rule="evenodd" clip-rule="evenodd" d="M9.28 4.97a.75.75 0 010 1.06L7.31 8l1.97 1.97a.75.75 0 11-1.06 1.06L5.47 8.5a.75.75 0 010-1.06l2.75-2.75a.75.75 0 011.06 0Z" fill="currentColor"/>
      <path d="M1 8a.75.75 0 01.75-.75h6.5a.75.75 0 010 1.5h-6.5A.75.75 0 011 8Z" fill="currentColor"/>
    </svg>
    Exit<span class="admin-banner__exit-long">&nbsp;superadmin mode</span>
  </a>
</div>

<router-outlet></router-outlet>
